import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const StarRating = ({ value, onChange }) => {
  const [hover, setHover] = useState(0);
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {[1,2,3,4,5].map(i => (
        <span key={i} onClick={() => onChange(i)} onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(0)}
          style={{ fontSize: 32, cursor: 'pointer', color: (hover || value) >= i ? '#f59e0b' : '#d1d5db', transition: 'color 0.1s' }}>★</span>
      ))}
    </div>
  );
};

export default function FormPage() {
  const { slug } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [values, setValues] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get('/api/forms/public/' + slug)
      .then(r => { setForm(r.data); setLoading(false); })
      .catch(e => { setError(e.response?.data?.error || 'Form bulunamadı'); setLoading(false); });
  }, [slug]);

  const validate = () => {
    const errs = {};
    form.fields.forEach(f => {
      if (f.is_required && !['divider','heading'].includes(f.field_type)) {
        const val = values[f.id];
        if (!val || (Array.isArray(val) && val.length === 0) || val === '') {
          errs[f.id] = f.label + ' alanı zorunludur';
        }
      }
    });
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      const res = await axios.post('/api/forms/public/' + slug + '/submit', values);
      setSuccessMsg(res.data.message);
      setSubmitted(true);
    } catch(err) {
      alert(err.response?.data?.error || 'Gönderim başarısız');
    }
    setSubmitting(false);
  };

  const setValue = (fieldId, val) => {
    setValues(prev => ({ ...prev, [fieldId]: val }));
    if (errors[fieldId]) setErrors(prev => ({ ...prev, [fieldId]: null }));
  };

  const renderField = (field) => {
    const inputStyle = { width: '100%', padding: '11px 14px', border: `1.5px solid ${errors[field.id] ? '#ef4444' : '#e5e7eb'}`, borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', transition: 'border-color 0.2s' };
    switch (field.field_type) {
      case 'divider': return <hr style={{ border: 'none', borderTop: '2px solid #e5e7eb', margin: '8px 0' }} />;
      case 'heading': return <div style={{ fontWeight: 800, fontSize: 18, color: '#1a1a2e', paddingTop: 8 }}>{field.label}</div>;
      case 'textarea':
        return <textarea value={values[field.id] || ''} onChange={e => setValue(field.id, e.target.value)} placeholder={field.placeholder} rows={4}
          style={{ ...inputStyle, resize: 'vertical' }} />;
      case 'select':
        return <select value={values[field.id] || ''} onChange={e => setValue(field.id, e.target.value)} style={inputStyle}>
          <option value="">{field.placeholder || 'Seçiniz...'}</option>
          {(field.options || []).map((o, i) => <option key={i} value={o}>{o}</option>)}
        </select>;
      case 'radio':
        return <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {(field.options || []).map((o, i) => (
            <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14, color: '#374151', padding: '10px 14px', border: `1.5px solid ${values[field.id] === o ? '#E30613' : '#e5e7eb'}`, borderRadius: 10, background: values[field.id] === o ? 'rgba(227,6,19,0.04)' : 'white', transition: 'all 0.15s' }}>
              <input type="radio" checked={values[field.id] === o} onChange={() => setValue(field.id, o)} style={{ accentColor: '#E30613' }} /> {o}
            </label>
          ))}
        </div>;
      case 'checkbox':
        return <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {(field.options || []).map((o, i) => {
            const checked = (values[field.id] || []).includes(o);
            return (
              <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14, color: '#374151', padding: '10px 14px', border: `1.5px solid ${checked ? '#E30613' : '#e5e7eb'}`, borderRadius: 10, background: checked ? 'rgba(227,6,19,0.04)' : 'white', transition: 'all 0.15s' }}>
                <input type="checkbox" checked={checked} style={{ accentColor: '#E30613' }}
                  onChange={e => { const cur = values[field.id] || []; setValue(field.id, e.target.checked ? [...cur, o] : cur.filter(x => x !== o)); }} /> {o}
              </label>
            );
          })}
        </div>;
      case 'rating':
        return <StarRating value={values[field.id] || 0} onChange={v => setValue(field.id, v)} />;
      case 'date':
        return <input type="date" value={values[field.id] || ''} onChange={e => setValue(field.id, e.target.value)} style={inputStyle} />;
      default:
        return <input type={field.field_type} value={values[field.id] || ''} onChange={e => setValue(field.id, e.target.value)}
          placeholder={field.placeholder} style={inputStyle} />;
    }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ fontSize: 14, color: '#9ca3af' }}>Yükleniyor...</div>
    </div>
  );

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 48, textAlign: 'center', maxWidth: 400, boxShadow: '0 8px 40px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>😕</div>
        <div style={{ fontWeight: 700, fontSize: 18, color: '#1a1a2e', marginBottom: 8 }}>Form Bulunamadı</div>
        <div style={{ fontSize: 14, color: '#9ca3af' }}>{error}</div>
      </div>
    </div>
  );

  if (submitted) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 48, textAlign: 'center', maxWidth: 440, boxShadow: '0 8px 40px rgba(0,0,0,0.1)' }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(52,199,89,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 36 }}>✅</div>
        <div style={{ fontWeight: 800, fontSize: 22, color: '#1a1a2e', marginBottom: 10 }}>Teşekkürler!</div>
        <div style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.6 }}>{successMsg}</div>
        <div style={{ marginTop: 24, padding: '12px', background: '#f9fafb', borderRadius: 10 }}>
          <img src="/uploads/assets/logo.png" alt="Petlas" style={{ height: 32, objectFit: 'contain' }} />
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: '32px 16px', fontFamily: "'Segoe UI', Arial, sans-serif" }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #1a0000 0%, #2d0000 40%, #E30613 100%)', borderRadius: '20px 20px 0 0', padding: '32px 36px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.06)', top: -100, right: -80 }} />
          <img src="/uploads/assets/logo.png" alt="Petlas" style={{ height: 36, objectFit: 'contain', filter: 'brightness(0) invert(1)', marginBottom: 20, display: 'block' }}
            onError={e => e.target.style.display = 'none'} />
          <h1 style={{ color: 'white', margin: 0, fontSize: 24, fontWeight: 800, lineHeight: 1.3 }}>{form.title}</h1>
          {form.description && <p style={{ color: 'rgba(255,255,255,0.7)', margin: '10px 0 0', fontSize: 14, lineHeight: 1.6 }}>{form.description}</p>}
        </div>

        {/* Form */}
        <div style={{ background: 'white', borderRadius: '0 0 20px 20px', padding: '32px 36px', boxShadow: '0 8px 40px rgba(0,0,0,0.1)' }}>
          <form onSubmit={handleSubmit}>
            {form.fields.map((field, i) => (
              <div key={field.id} style={{ marginBottom: 22 }}>
                {!['divider','heading'].includes(field.field_type) && (
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14, color: '#374151' }}>
                    {field.label}
                    {field.is_required && <span style={{ color: '#E30613', marginLeft: 4 }}>*</span>}
                  </label>
                )}
                {renderField(field)}
                {field.help_text && <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 5 }}>{field.help_text}</div>}
                {errors[field.id] && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 5 }}>⚠️ {errors[field.id]}</div>}
              </div>
            ))}

            {form.fields.filter(f => !['divider','heading'].includes(f.field_type)).length > 0 && (
              <button type="submit" disabled={submitting}
                style={{ width: '100%', padding: '14px', background: submitting ? '#ccc' : '#E30613', color: 'white', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: submitting ? 'not-allowed' : 'pointer', marginTop: 8, boxShadow: submitting ? 'none' : '0 4px 16px rgba(227,6,19,0.3)', transition: 'all 0.2s' }}>
                {submitting ? 'Gönderiliyor...' : 'Gönder →'}
              </button>
            )}
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#bbb' }}>
          Petlas Eğitim ve Akademi Portalı
        </div>
      </div>
    </div>
  );
}
